import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const CATEGORIES = ["custom", "payment", "technical", "other"];
export const READ_EVENT = "fmo:messages-read";

export const useUnread = (url, enabled = true) => {
  const [count, setCount] = useState(0);
  const load = useCallback(() => {
    if (enabled) api.get(url).then(({ data }) => setCount(data.count)).catch(() => {});
  }, [url, enabled]);
  useEffect(() => {
    load();
    const id = setInterval(load, 30000);
    window.addEventListener(READ_EVENT, load);
    return () => {
      clearInterval(id);
      window.removeEventListener(READ_EVENT, load);
    };
  }, [load]);
  return count;
};

export const UnreadBadge = ({ count, testId }) =>
  count > 0 ? (
    <span className="ms-1 inline-flex min-w-[1.25rem] items-center justify-center rounded-full bg-[var(--red,#b3141c)] px-1.5 text-[0.65rem] font-bold text-white" data-testid={testId}>
      {count > 99 ? "99+" : count}
    </span>
  ) : null;
